import { ROUTES } from '../constants/routes';
import { ORDER_PAGE_MODE, type OrderPageMode } from '../constants/OrderPageModeConstants';

/** `/dat-hang` = affiliate (KOL/KOC + đặt hàng thường), còn lại = livestream. */
export default class OrderPageModeHelper {
    private constructor() {}

    public static fromPathname(pathname: string): OrderPageMode {
        const normalized = pathname.replace(/\/+$/, '');
        return normalized === ROUTES.order.url ? ORDER_PAGE_MODE.affiliate : ORDER_PAGE_MODE.livestream;
    }

    public static getCurrent(): OrderPageMode {
        if (typeof window === 'undefined') {
            return ORDER_PAGE_MODE.livestream;
        }

        return this.fromPathname(window.location.pathname);
    }

    public static getCurrentProductId(): number {
        if (typeof window === 'undefined') {
            return 0;
        }

        const search = new URLSearchParams(window.location.search);
        const productId = Number.parseInt(search.get('productId') || search.get('productid') || '0', 10);
        return Number.isFinite(productId) && productId > 0 ? productId : 0;
    }

    public static getCurrentRef(): string {
        if (typeof window === 'undefined') {
            return '';
        }

        const search = new URLSearchParams(window.location.search);
        return (search.get('ref') || '').trim();
    }
}
